// returns a binder which removes a node from DOM (leaving a comment in its place) or puts it back
export default function existence(switcher) {
  if (switcher === void 0) {
    switcher = true;
  }
  // one binder can be bound to many nodes, so every node gets its own comment
  var comments = new WeakMap();
  // like display: the node's own value (a field's text) is not the flag
  return {
    on: null,
    getValue: null,
    setValue: function setValue(value) {
      var comment = comments.get(this);
      if (!comment) {
        var tagName = this.tagName,
          id = this.id;
        var classes = (this.getAttribute('class') || '').split(/\s+/).filter(Boolean);
        var commentText = tagName;
        if (id) {
          commentText += "#" + id;
        }
        if (classes.length) {
          commentText += "." + classes.join('.');
        }
        comment = window.document.createComment(commentText);
        comments.set(this, comment);
      }
      var exists = value;
      if (typeof switcher === 'function') {
        exists = switcher(value);
      } else if (!switcher) {
        exists = !value;
      }
      if (exists) {
        // __replacedByNode is read by Matreshka.Array rendering
        delete this.__replacedByNode;
        if (comment.parentNode) {
          comment.parentNode.insertBefore(this, comment);
          comment.parentNode.removeChild(comment);
        }
      } else {
        this.__replacedByNode = comment;
        if (this.parentNode) {
          this.parentNode.insertBefore(comment, this);
          this.parentNode.removeChild(this);
        }
      }
    }
  };
}